<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 68 50.8">
        <title>{{strings['PneuOffer.TTNoiseClass']}}: {{decibel}}dB ({{catUpper}})</title>
        <defs>
            <path id="a" d="M0 .4h25.9v31.3H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <g transform="translate(0 18.5)">
                <mask id="b" fill="#fff">
                    <use xlink:href="#a" width="100%" height="100%" />
                </mask>
                <path d="M8.2 31.7c-4.5 0-8.2-7-8.2-15.6C0 7.4 3.7.4 8.2.4h9.5c4.5 0 8.2 7 8.2 15.7 0 8.6-3.7 15.6-8.2 15.6z" fill="#231f20" mask="url(#b)" />
            </g>
            <path d="M18.6 50.4c-4.5 0-8-7-8-15.7 0-8.8 3.3-15.8 7.9-15.8" stroke="#fefefe" stroke-width=".3" />
            <path d="M18.5 44.5c-2.1 0-3.8-4.6-3.8-10.2s1.7-10.2 3.8-10.2c2.1 0 3.9 4.6 3.9 10.2s-1.8 10.2-3.9 10.2m.4-21c-2.5 0-4.5 4.8-4.5 10.7 0 6 2 10.9 4.5 10.9s4.5-4.9 4.5-10.9-2-10.8-4.5-10.8" fill="#fefefe" />
            <path d="m15.7 27.6-.4.7-.5 2.2-.2 2.4-.1 3.2.6 3.5.6 1.8c1.3 0 2.5-3 2.5-6.6 0-3.6-1.2-7.2-2.5-7.2" fill="#fefefe" />
            <path d="M10.2 50.5c-4.6 0-8.3-7.2-8.3-16 0-8.6 3.8-16 8.4-16m2.4 32c-4.6 0-8.3-7.1-8.3-15.8 0-8.8 3.8-16 8.4-16M10.3 19.3H7.8m1.5.8H6.9m1.7.7H6m1.7 1H5.4m4.8 28H7.9m-.7-27H4.7m1.7 1.3H4.1m1.8 1.4H3.4m1.9 2H2.9m2 2.3H2.3M9.3 49H6.9m1.4-1H6m1.6-1H5.1m1.7-1.3-2.6-.2m2-1.4H3.6m1.7-1.6L3 42.5M5 40.3l-2.4-.1m2.1-2-2.5-.1m2.3-2.4L2 35.6m2.6-2.7L2 32.7" stroke="#fefefe" stroke-width=".3" />
            <path d="M14.2 50.6c-4.4 0-8-7.2-8-16 0-8.7 3.6-16 8.1-16m2.3 32c-4.4 0-8-7.1-8-15.9 0-8.7 3.6-16 8-16M14.3 19.4h-2.4m1.4.8H11m1.6.7h-2.3m1.6 1H9.5m4.6 28H12m-.7-27H8.9m1.7 1.3H8.3m1.8 1.4H7.7m1.8 2H7.2M9 30l-2.4-.1m6.7 19.4H11m1.4-1H10m1.5-1H9.3m1.6-1.3-2.5-.2m1.8-1.4H8m1.7-1.6-2.3-.1M9 40.4l-2.3-.1m2-2-2.4-.1m2.2-2.5H6.2M8.7 33l-2.3-.2" stroke="#fefefe" stroke-width=".3" />

            <text v-if="catUpper != 'A'" font-family="Verdana, sans-serif" font-size="8" font-weight="normal" fill="#231F20"><tspan x="26.5059" y="49.5">A</tspan></text>
            <text v-if="catUpper == 'A'" font-family="Verdana-Bold, Verdana, sans-serif" font-size="12" font-weight="bold" fill="#231f20" transform="translate(0 -1)"><tspan x="26.5" y="48.5">A</tspan></text>

            <text v-if="catUpper != 'B'" font-family="Verdana, sans-serif" font-size="8" fill="#231f20" transform="translate(0 -1)"><tspan x="36" y="49.5">B</tspan></text>
            <text v-if="catUpper == 'B'" font-family="Verdana-Bold, Verdana, sans-serif" font-size="12" font-weight="bold" fill="#231F20"><tspan x="31.9746" y="48.5">B</tspan></text>

            <text v-if="catUpper != 'C'" font-family="Verdana, sans-serif" font-size="8" fill="#231f20" transform="translate(0 -1)"><tspan x="41.6" y="49.5">C</tspan></text>
            <text v-if="catUpper == 'C'" font-family="Verdana-Bold, Verdana, sans-serif" font-size="12" font-weight="bold" fill="#231F20"><tspan x="37.5918" y="48.5">C</tspan></text>

            <path d="M53.8 28A22.3 22.3 0 0 0 53 9.7zM65 32.7a34 34 0 0 0-1-28.2zM59.5 30a27.7 27.7 0 0 0-.8-22.9zM46.9.4v38.3L32 29.5H15.3V9.8h16.8z" fill="#fefefe" />
            <path d="M53.8 28A22.3 22.3 0 0 0 53 9.7m11.9 23a34 34 0 0 0-1-28.2m-4.5 25.7a27.7 27.7 0 0 0-.8-22.9M46.9.4v38.3L32 29.5H15.3V9.8h16.8z" stroke="#231f20" stroke-width=".8" stroke-linecap="round" stroke-linejoin="round" />
            <text font-family="Verdana-Bold, Verdana, sans-serif" font-size="10" font-weight="bold" fill="#231f20" transform="translate(0 -1)"><tspan x="18.1" y="22">{{decibel}}</tspan></text>
            <text font-family="Verdana, sans-serif" font-size="8" fill="#231f20" transform="translate(0 -1)"><tspan x="33.7" y="22.5">dB</tspan></text>
        </g>
    </svg>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            category: {
                type: String,
                required: true
            },
            decibel: {
                type: Number,
                required: true
            }
        },
        computed: {
            ...mapState([
                'strings'
            ]),
            catUpper() {
                return this.category.toUpperCase();
            }
        }
    };
</script>